import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20overlapping%20circles%20in%20coral%20rose%20and%20golden%20amber%20tones%2C%20minimalist%20modern%20design%2C%20smooth%20textures%2C%20feeling%20of%20warmth%20community%20and%20connection%2C%20artistic%20abstract%20composition%20with%20gentle%20flowing%20shapes&width=1600&height=900&seq=hero-nantong-bg&orientation=landscape"
        alt="男同网 - 温暖包容的男同社区"
        className="absolute inset-0 w-full h-full object-cover"
        title="男同网 - 男同社群交友与资讯平台"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 font-heading leading-tight">
            找到志同道合的伙伴
          </h1>
          <p className="text-base md:text-lg text-background-50/85 mb-8 max-w-xl mx-auto leading-relaxed">
            男同网是专为男同群体打造的综合性平台，提供男同交友、社群互动、生活资讯与健康指南。在这里，探索真实的自我，构建温暖包容的男同社区。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/jiaoyou"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer"
            >
              开始交友
            </Link>
            <Link
              to="/category/shequn"
              className="px-8 py-3 bg-background-50/15 text-background-50 border border-background-50/30 rounded-full text-sm font-medium whitespace-nowrap hover:bg-background-50/25 transition-all cursor-pointer"
            >
              探索社群
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}